import { LineItemNumericCalculatorField } from "components/formFields/LineItemNumericCalculatorField";
import { LineTableCell } from "components/formFields/LineTableCell";

import { LINE_ITEM_METADATA } from "editConfig";

export function LinePicked(props) {
  const { value, onValueChange, objectType, lineReadOnly = false } = props;

  const metadata = LINE_ITEM_METADATA[objectType].picked;

  return (
    <LineTableCell sx={{ minWidth: "4rem" }}>
      <LineItemNumericCalculatorField
        name="picked"
        value={value}
        onValueChange={onValueChange}
        metadata={metadata}
        lineReadOnly={lineReadOnly}
      />
    </LineTableCell>
  );
}
